module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messagedetails"
  }, [_c('div', {
    staticClass: "messagedetails-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "messagedetails-title"
  }, [_c('h1', [_vm._v("系统消息")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sendTime))])]), _vm._v(" "), _c('div', {
    staticClass: "messagedetails-content"
  }, [_c('p', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v(_vm._s(_vm.content))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d22a3460"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/messagedetails.vue
// module id = 1041
// module chunks = 1